// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var LogsController = function ($scope, $routeParams, Logs) {

    function setDefaultPeriod() {
        $scope.filter.after = moment().subtract(1, 'hours').toISOString(true);
        $scope.filter.before = moment().toISOString(true);
    }

    function getBeforeFromAfter(after) {
        return moment(after).add(1, 'hours').toISOString(true);
    }

    function getAfterFromBefore(before) {
        return moment(before).subtract(1, 'hours').toISOString(true);
    }

    function getISODateOrDefault(date) {
        return moment(date).isValid() ? moment(date).toISOString(true) : moment().toISOString(true);
    }

    function setPeriodFilterDefaults() {
        if (!moment($scope.filter.after).isValid() && !moment($scope.filter.before).isValid()) {
            setDefaultPeriod();
        } else if (moment($scope.filter.after).isValid() && !moment($scope.filter.before).isValid()) {
            $scope.filter.after = getISODateOrDefault($scope.filter.after);
            $scope.filter.before = getBeforeFromAfter($scope.filter.after);
        } else if (!moment($scope.filter.after).isValid() && moment($scope.filter.before).isValid()) {
            $scope.filter.before = getISODateOrDefault($scope.filter.before);
            $scope.filter.after = getAfterFromBefore($scope.filter.before);
        } else {
            $scope.filter.after = moment($scope.filter.after).toISOString(true);
            $scope.filter.before = moment($scope.filter.before).toISOString(true);
        }
    }

    $scope.filter = {
        application: $routeParams.application,
        severity: $routeParams.severity ? $routeParams.severity : "Info",
        before: getISODateOrDefault($routeParams.before),
        after: getAfterFromBefore(getISODateOrDefault($routeParams.before)),
        min: $routeParams.from,
        requestLogId: $routeParams.requestLogId,
        message:""
    };

    $scope.loadLogs = function () {
        setPeriodFilterDefaults();

        $scope.logs = $scope.paginator(function(options, callback) {
                return Logs.query(options, function() { callback(); });
            }, {
                application: $scope.filter.application,
                severity: $scope.filter.severity,
                before: $scope.filter.before,
                after: $scope.filter.after,
                min: $scope.filter.from,
                requestLogId: $scope.filter.requestLogId,
                message : $scope.filter.message
            }, 50);
    };

    $scope.loadLogs();
};
LogsController.$inject = ['$scope', '$routeParams', 'Logs'];
